import getApiClient from "../../api/OpenClient";

import { isSurveyLoggingEnabled } from "../../AppSettings";

// What is the first step.  We want to know this so that we only send the user_agent data
// once.
const first_step = "start"

// Global variable that stores what step the user was last on.
let last_step = ""

// A list of steps we should exclude from logging.  Currently only on the complete
// step because complete fires after the POST of a mask fitting, the token won't exist
// and the GET will cause a 404 response.
let exclude_steps_from_logging = [ "complete" ]


// We base64 encode the user agent string and send it as a query parameter.  The only thing
// is that a couple of base64 characters are not URL safe and need to be converted.
//
// Valid base 64 characters:
// ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=
//
// base64 URL encoded
// ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789._-
//
export const base64_url_encode = (input) => {
    try {
        let base64 = btoa(input);
        return base64.split("+").join(".").split("/").join("_").split("=").join("-");
    } catch (e) {
        console.error(`An error occurred while encoding the string: ${e}`);
        return null;
    }
}

export const logStep = (step, token) => {

    if ( ! isSurveyLoggingEnabled() ) {
        // Survey logging has been disabled NOP.
        return
    }

    // When the step parameter is sent to the tokens GET operation it logs
    // when the user got to that stage in the survey for analytics purposes.
    //
    // The way our React code is structured right now the step parsing code
    // gets processed multiple times so only log the first instance of arriving
    // at a survey step by using a global variable.

    if ( last_step !== step) {
        last_step = step;

        if ( exclude_steps_from_logging.includes( step ) ) {
            return;
        }

        let log_url = `/tokens/${token}?step=${step}`;


        if (step === first_step) {

            // Save the user agent on the first visited page.
            const agent = base64_url_encode(navigator.userAgent);

            if (agent !== null) {
                log_url = `/tokens/${token}?step=${step}&agent=${agent}`;
            }
        }


        getApiClient().get(log_url).then(
            r => {
                //  Do nothing we don't need the response.
                 });
    }
}
